import { HardwareRequestStatus } from "src/api/types.generated";

import { HACKER_STATUS_MAP } from "./constants";
import { THardwareItemCardProps } from "./types";

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

export const getAvailableStatuses = (
  currentStatus: HardwareRequestStatus,
  userType: "organizer" | "hacker"
): HardwareRequestStatus[] => {
  if (userType === "hacker") {
    // Hackers can only cancel REQUESTED orders
    if (currentStatus === HardwareRequestStatus.Requested) {
      return [HardwareRequestStatus.Cancelled];
    }
    return []; // No other status changes allowed for hackers
  }

  // Organizers can change to any status except the current one
  return Object.values(HardwareRequestStatus).filter(
    (status) => status !== currentStatus
  );
};

export const getStatusDisplayName = (status: HardwareRequestStatus): string => {
  return HACKER_STATUS_MAP[status] || status;
};

export const getStatusDisplayNameForUser = (
  status: HardwareRequestStatus,
  userType: "organizer" | "hacker"
): string => {
  if (userType === "organizer") {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }
  return HACKER_STATUS_MAP[status] || status;
};

export const groupItemsByRequest = (items: THardwareItemCardProps[]) => {
  return items.reduce((acc, item) => {
    const requestKey = item.requestId ? item.requestId.toString() : "unknown";
    if (!acc[requestKey]) {
      acc[requestKey] = [];
    }
    acc[requestKey].push(item);
    return acc;
  }, {} as Record<string, THardwareItemCardProps[]>);
};
